<template>
  <b-form @submit="onSubmit">
    <b-card no-body class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <b>{{ perfil.nome }}</b>
          <div class="d-flex flex-row-reverse">
            <b-button type="submit" variant="exitos">Salvar</b-button>

            <router-link
              :to="{ name: 'clientes_edit', params: { id: perfil.cliente_id } }"
              class="btn btn-outline-muted mr-2"
              >Voltar para Listagem</router-link
            >
          </div>
        </div>
      </template>

      <b-tabs pills card vertical class="edit-menu-sidebar">
        <b-tab active>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.dados_basicos"
            />
            Dados Básicos
          </template>
          <DadosBasicos ref="dados_basicos" />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-form>
</template>

<script>
import { mapActions, mapState } from "vuex";

import DadosBasicos from "./Form/DadosBasicos.vue";
import Endereco from "./Form/Endereco.vue";

export default {
  components: { DadosBasicos, Endereco },
  data: () => ({
    validations: {
      dados_basicos: true,
    },
  }),
  computed: {
    ...mapState("perfis", ["perfil"]),
  },
  methods: {
    ...mapActions("perfis", ["ActionSave", "ActionShow"]),
    async onSubmit(event) {
      event.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          await this.ActionSave(this.perfil);
          this.$emit("saved", this.perfil.id);

          this.$notifications.addNotification({
            message: "Registro salvo com sucesso",
            type: "success",
          });
        } catch (error) {
          let error_message = "Erro ao salvar";
          this.$notifications.addNotification({
            message: error_message,
            icon: "exclamation-triangle",
            type: "danger",
          });
        }
      }
    },
    isValid() {
      this.validations.dados_basicos = this.$refs.dados_basicos.isValid();
      return Object.values(this.validations).every(Boolean);
    },
    async loadData(id) {
      try {
        await this.ActionShow(id);
        this.$refs["dados_basicos"].validateProfileType();
      } catch (error) {
        this.$notifications.addNotification({
          message: error.data.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });
        this.$router.push({ name: "clientes_list" });
      }
    },
  },
  async created() {
    await this.loadData(this.$route.params.id);
  },
};
</script>
